<div class="pb-16">
  <pax-funnel-header
    [allMilestones]="allMilestones"
    (back)="navigateBack.emit()"
    [enableBackButton]="enableBackButton"
  ></pax-funnel-header>

  <app-checkout-form-wrapper>
    <!-- Main Content Section -->
    <pax-section
      [sectionTitle]="sectionTitle"
      [sectionSubtitle]="subtitle"
      [emojis]="emojis"
    >
      <div class="sm:px-6">
        <pax-form-factory
          [formConfiguration]="formConfiguration"
          (formSubmit)="formSubmit.emit($event)"
          (formChange)="formChange.emit($event)"
          [data]="data"
          [isDisabled]="(externalSystemCommunicationStateService.hasAnyPendingBackendRequests$ | async) ?? false"
        >
        </pax-form-factory>
      </div>
    </pax-section>

    <!-- Main Navigation Panel -->
    <pax-bottom-navigation-panel
      [infoDialog]="infoDialogEnhanced"
      (continue)="submitForm()"
      (skip)="navigateNext.emit()"
      [enableSkipButton]="enableSkipButton"
      [isBusy]="(externalSystemCommunicationStateService.hasAnyPendingBackendRequests$ | async) ?? false"
    ></pax-bottom-navigation-panel>
  </app-checkout-form-wrapper>
</div>

<ng-template #infoDialogTemplate>
  <!-- We sometimes have to show a legal disclaimer, depending on the information we show in the dialog. -->
  @if (infoDialog?.showLegalDisclaimer) {
  <div class="py-5">
    <pax-alert [markdown]="legalDisclaimerInfoMarkdown" variant="info" />
  </div>
  }
</ng-template>
